var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 60,
    viewBox: "0 0 70 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_959_1745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1791 11.0559C17.5342 11.0559 17.8857 10.9957 18.2138 10.8788C18.5418 10.7618 18.8398 10.5904 19.0909 10.3744C19.3419 10.1583 19.5411 9.90182 19.6769 9.61953C19.8128 9.33723 19.8827 9.03467 19.8827 8.72911V2.33047C19.8833 2.0246 19.8138 1.72164 19.6782 1.43892C19.5426 1.15619 19.3435 0.899256 19.0924 0.682804C18.8413 0.466351 18.5431 0.294631 18.2148 0.177469C17.8865 0.0603064 17.5346 0 17.1792 0C16.8238 0 16.4719 0.0603064 16.1436 0.177469C15.8153 0.294631 15.517 0.466351 15.2659 0.682804C15.0148 0.899256 14.8158 1.15619 14.6802 1.43892C14.5445 1.72164 14.475 2.0246 14.4756 2.33047V8.72911C14.4756 9.3462 14.7604 9.93802 15.2674 10.3744C15.7745 10.8107 16.4621 11.0559 17.1791 11.0559Z",
    fill: "url(#paint0_linear_959_1745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5699 11.0562C45.9249 11.0562 46.2765 10.996 46.6045 10.8791C46.9325 10.7622 47.2306 10.5908 47.4816 10.3747C47.7327 10.1587 47.9318 9.90218 48.0677 9.61988C48.2035 9.33759 48.2735 9.03502 48.2735 8.72947V2.33082C48.2735 1.71372 47.9886 1.12189 47.4816 0.68553C46.9746 0.249172 46.2869 0.00402832 45.5699 0.00402832C44.8528 0.00402832 44.1652 0.249172 43.6581 0.68553C43.1511 1.12189 42.8663 1.71372 42.8663 2.33082V8.72947C42.8663 9.03502 42.9362 9.33759 43.0721 9.61989C43.2079 9.90218 43.4071 10.1587 43.6582 10.3747C43.9092 10.5908 44.2073 10.7622 44.5353 10.8791C44.8633 10.996 45.2148 11.0562 45.5699 11.0562Z",
    fill: "url(#paint1_linear_959_1745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2861 23.5669C46.0784 23.567 42.9429 24.3857 40.2759 25.9194C37.6089 27.4532 35.5302 29.6331 34.3028 32.1836C33.0754 34.734 32.7543 37.5405 33.3801 40.248C34.006 42.9555 35.5507 45.4425 37.8188 47.3945C40.087 49.3464 42.9768 50.6757 46.1228 51.2142C49.2688 51.7527 52.5297 51.4763 55.4932 50.4198C58.4566 49.3634 60.9895 47.5743 62.7715 45.279C64.5535 42.9836 65.5047 40.285 65.5046 37.5245C65.4998 33.8239 63.7895 30.2761 60.7489 27.6594C57.7084 25.0427 53.5859 23.5709 49.2861 23.5669ZM55.2737 44.5811L49.2863 41.6942L43.2988 44.5811L44.6389 38.7884L39.5985 34.7797L46.414 34.0864L49.2863 28.7221L52.1585 34.0864L58.9741 34.7797L53.9337 38.7884L55.2737 44.5811Z",
    fill: "url(#paint2_linear_959_1745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.166 5.24207H22.4673V7.56429H40.166V5.24207Z",
    fill: "url(#paint3_linear_959_1745)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74171 45.6642H32.9106C30.8229 42.5621 29.9843 38.9535 30.5251 35.399C31.0659 31.8445 32.9558 28.5433 35.901 26.0084C38.8463 23.4734 42.682 21.8468 46.8121 21.3812C50.9422 20.9156 55.1353 21.6371 58.7398 23.4337L58.741 9.89293C58.7392 8.58273 58.1337 7.32664 57.0571 6.40024C55.9806 5.47384 54.521 4.95279 52.9986 4.95142H50.9657V7.85419H52.9986C53.6267 7.85475 54.229 8.0697 54.6732 8.4519C55.1174 8.8341 55.3673 9.35234 55.3681 9.89293V15.4215H7.37282V9.89293C7.37349 9.3524 7.62328 8.83417 8.06739 8.45196C8.5115 8.06975 9.11365 7.85477 9.74171 7.85419H11.7746V4.95142H9.74171C8.21944 4.95291 6.76002 5.47401 5.68361 6.4004C4.6072 7.32679 4.00172 8.58282 4 9.89293V40.7227C4.00173 42.0328 4.60721 43.2888 5.68361 44.2152C6.76002 45.1416 8.21945 45.6627 9.74171 45.6642Z",
    fill: "url(#paint4_linear_959_1745)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_959_1745",
    x: 0,
    y: 0,
    width: 69.5046,
    height: 59.4824,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.879167 0 0 0 0 0.813229 0 0 0 0 0.813229 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_959_1745"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_959_1745",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_959_1745",
    x1: 17.0412,
    y1: 12.1858,
    x2: 17.4564,
    y2: 0.0106606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197633,
    stopColor: "#073B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4452,
    stopColor: "#1C648E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#2587B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#289FD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_959_1745",
    x1: 45.4319,
    y1: 12.1857,
    x2: 45.8468,
    y2: 0.0146757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197633,
    stopColor: "#073B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4452,
    stopColor: "#1C648E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#2587B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#289FD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_959_1745",
    x1: 47.2135,
    y1: 52.5625,
    x2: 47.2135,
    y2: 23.8149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0156724,
    stopColor: "#FFB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276271,
    stopColor: "#E3A608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565452,
    stopColor: "#C29211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767206,
    stopColor: "#58542F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002147"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_959_1745",
    x1: 30.865,
    y1: 7.80161,
    x2: 30.8706,
    y2: 5.24134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197633,
    stopColor: "#073B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4452,
    stopColor: "#1C648E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.630208,
    stopColor: "#2587B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#289FD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27AAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_959_1745",
    x1: 64.5,
    y1: 42.5,
    x2: 21.7838,
    y2: -21.4076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247023,
    stopColor: "#002E53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501463,
    stopColor: "#003D62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690614,
    stopColor: "#00527C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916086,
    stopColor: "#006393"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenaceIcon);
export default __webpack_public_path__ + "static/media/MaintenaceIcon.27c9403976b1987771e2607d9607ff7b.svg";
export { ForwardRef as ReactComponent };